import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteInternal } from 'src/store/actions/internal-actions';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { IInternal } from 'src/types/internal';

interface Props {
    data: IInternal;
}

const DeleteInternalAction: React.FunctionComponent<Props> = ({ data: { id } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };
    return (
        <>
            <button className="btn btn-secondary" type="button" onClick={() => setOpened(true)}>
                <FontAwesomeIcon icon={faTrash} />
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                deleteInternal(id, handleClose, (errorMessage: string) => {
                                    handleClose();
                                    toast.error(errorMessage);
                                }),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteInternalAction;
